import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

export class Apps extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={22} width={22}>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(-913 -11)" fill="#FFF">
            <g transform="translate(910 8)">
              <g transform="translate(3 3)">
                <rect width="4" height="4" rx="1" />
                <rect x="7" width="4" height="4" />
                <rect x="14" width="4" height="4" rx="1" />
                <rect y="7" width="4" height="4" />
                <rect x="7" y="7" width="4" height="4" />
                <rect x="14" y="7" width="4" height="4" />
                <rect y="14" width="4" height="4" rx="1" />
                <rect x="7" y="14" width="4" height="4" />
                <rect x="14" y="14" width="4" height="4" rx="1" />
              </g>
            </g>
          </g>
        </g>
      </Icon>
    );
  }
}

Apps.displayName = "Apps";
Apps.vstuiName = "Icon";

export class Tools extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={24} width={24}>
        <defs>
          <polygon
            id="path-1"
            points="0 0.830410245 23.338 0.830410245 23.338 19 0 19"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <g>
            <g>
              <g transform="translate(0 1.645)">
                <mask id="mask-2" fill="#fff">
                  <use xlinkHref="#path-1" />
                </mask>
                <path
                  d="M2,17 L19.999,17 L2,3.501 L2,17 Z M22.007,19 L1.33,19 C0.597,19 0,18.403 0,17.67 L0,2.162 C0,1.654 0.282,1.198 0.735,0.972 C1.19,0.747 1.724,0.791 2.129,1.098 L22.806,16.605 C23.265,16.949 23.451,17.546 23.27,18.09 C23.089,18.635 22.581,19 22.007,19 Z"
                  fill="#FFF"
                  mask="url(#mask-2)"
                />
              </g>
              <path
                d="M20.9658,-3.55271368e-15 L15.0338,-3.55271368e-15 C14.1868,-3.55271368e-15 13.4998,0.687 13.4998,1.534 L13.4998,8.771 L15.5218,10.287 L15.5418,2 L20.4998,2.042 L20.4998,4.812 L17.9578,4.812 L17.9578,5.812 L20.4998,5.812 L20.4998,8.32 L17.9578,8.32 L17.9578,9.32 L20.4998,9.32 L20.4998,14.021 L22.4998,15.521 L22.4998,1.534 C22.4998,0.687 21.8138,-3.55271368e-15 20.9658,-3.55271368e-15"
                fill="#FFF"
              />
            </g>
          </g>
        </g>
      </Icon>
    );
  }
}

Tools.displayName = "Tools";
Tools.vstuiName = "Icon";

export class Account extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={24} width={24}>
        <path d="M12,2c5.5,0,10,4.5,10,10s-4.5,10-10,10S2,17.5,2,12S6.5,2,12,2 M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12 c6.6,0,12-5.4,12-12S18.6,0,12,0L12,0z" />
        <path d="M15.8,13.9c-0.2-0.1-1-0.6-1.3-0.3C14.1,14,13,14.9,12,14.9v0v0c-1,0-2.1-0.9-2.5-1.3 c-0.3-0.3-1.1,0.2-1.3,0.3c-0.6,0.4-0.7,0.5-1.2,1.1c-0.3,0.3-0.5,0.7-0.7,1c1.3,1.8,3.4,3,5.7,3c2.4,0,4.5-1.2,5.7-3 c-0.2-0.3-0.4-0.7-0.7-1C16.6,14.5,16.4,14.3,15.8,13.9z" />
        <path d="M15.2,8.4c0,2-1.6,4-3.2,4s-3.2-2.1-3.2-4s1.4-3.6,3.2-3.6S15.2,6.4,15.2,8.4z" />
      </Icon>
    );
  }
}

Account.displayName = "Account";
Account.vstuiName = "Icon";

export class Help extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={14} width={14}>
        <path d="M7 1.6c3 0 5.4 2.4 5.4 5.4S10 12.4 7 12.4 1.6 10 1.6 7 4 1.6 7 1.6M7 0C3.1 0 0 3.1 0 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z" />
        <path d="M6.4 4.9v-2c-1.8.3-3.2 1.6-3.5 3.4h2c.2-.7.8-1.2 1.5-1.4zM9.1 6.3h2C10.8 4.6 9.4 3.2 7.7 3v2c.6.1 1.2.6 1.4 1.3zM7.6 9.1v2c1.8-.3 3.2-1.7 3.5-3.6H9.2c-.2.8-.8 1.4-1.6 1.6zM4.8 7.5H2.9c.2 1.8 1.7 3.3 3.5 3.6v-2c-.8-.2-1.4-.8-1.6-1.6z" />
      </Icon>
    );
  }
}

Help.displayName = "Help";
Help.vstuiName = "Icon";
